export enum IVolumeSnapshotDetailsPageTabs {
  Overview = 'overview',
}
